import {endpoint} from "@/utils/api/Conf";
import {User} from "@/types/User";

export const refreshRequest = async (refreshToken: string) => {

  try {
    const init: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({refresh_token: refreshToken}),
    }
    const response = await fetch(endpoint + 'auth/refresh', init);
    if (response.ok) {
      return await response.json() as User;
    }
    return false
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
